/* eslint-disable no-unused-vars */
import { ImageMediaUploadContainer, ImagePreview } from '../index';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { isAdminSelector, select_campaign_env } from 'store/selectors';
import { campaignEnvironment } from 'constants';

export const BottomContainer = ({ isNewCreative }) => {
  const environment = useSelector(select_campaign_env);
  const isAdmin = useSelector(isAdminSelector);

  return (
    <DisabledBox
      isDisabled={!isAdmin && environment === campaignEnvironment.edit && !isNewCreative}
    >
      <ImageMediaUploadContainer />
      <ImagePreview />
    </DisabledBox>
  );
};

const DisabledBox = styled.div`
  display: grid;
  gap: 40px;
  grid-template-columns: 1fr 290px;
  height: fit-content;
  max-height: 620px;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;
